import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { FormikSelect, FormikTextInput, PrimaryButton } from '@stashinvest/ui';
import { BanjoString, useBanjo } from '@stashinvest/react-banjo';
import LinkBankMicrosDisclosure from './LinkBankMicrosDisclosure';
import CheckExamplePartialSheet from './CheckExamplePartialSheet';
import { FormikFormErrorLogger } from '../formik-form/FormikFormErrorLogger';

const LinkBankMicrosForm = (props) => {
	const { submitting, onBeforeValidation = () => {} } = props;
	const { handleSubmit: formikHandleSubmit } = useFormikContext();
	const { getString } = useBanjo();
	const accountTypes = [
		{ id: 'CHECKING', name: 'Checking' },
		{ id: 'SAVINGS', name: 'Savings' },
	];

	// using <form> instead of Formik's <Form> so that we can call onBeforeValidation
	// before the Yup validation occurs
	const handleSubmit = useCallback(
		(e) => {
			e.preventDefault();
			onBeforeValidation();
			formikHandleSubmit(e);
		},
		[formikHandleSubmit, onBeforeValidation]
	);

	return (
		<form onSubmit={handleSubmit}>
			<FormikFormErrorLogger onValidationErrors={props.onValidationErrors} />
			<FormikSelect
				name="accountType"
				mb="s"
				label={getString('management/property/accountType')}
			>
				<option value="" defaultValue disabled>
					{getString('information/error/SelectAccountType')}
				</option>
				{accountTypes.map((x) => (
					<option key={x.id} value={x.id}>
						{x.name}
					</option>
				))}
			</FormikSelect>
			<FormikTextInput
				name="routingNumber"
				type="text"
				inputMode="decimal"
				label={getString('management/input/routingNumber')}
				mb="s"
				maxLength="9"
			/>
			<FormikTextInput
				name="accountNumber"
				type="text"
				inputMode="decimal"
				label={getString('management/input/externalBankAccountNumber')}
				mb="s"
			/>
			<FormikTextInput
				name="confirmAccountNumber"
				type="text"
				inputMode="decimal"
				label={getString('management/input/confirmExternalBankAccount')}
				mb="s"
			/>
			<CheckExamplePartialSheet />
			<LinkBankMicrosDisclosure />
			<PrimaryButton
				type="submit"
				loading={submitting}
				disabled={submitting}
				className="my-layoutSmall"
			>
				<BanjoString stringId="action/executeTask/linkExternalAccount" />
			</PrimaryButton>
		</form>
	);
};

LinkBankMicrosForm.propTypes = {
	submitting: PropTypes.bool,
	onValidationErrors: PropTypes.func,
	onBeforeValidation: PropTypes.func,
};

export default LinkBankMicrosForm;
